import React from "react";
import "./kpi-card.css";

type DeltaDir = "up" | "down";

interface Props {
  scope: string;
  /** CSS color for the scope dot — any valid CSS value, e.g. "var(--pos)" or "#4a8bc4" */
  dotColor: string;
  amount: React.ReactNode;
  subText?: string;
  delta?: string;
  deltaDir?: DeltaDir;
  loading?: boolean;
}

function KpiCard({
  scope,
  dotColor,
  amount,
  subText,
  delta,
  deltaDir,
  loading,
}: Props) {
  return (
    <div className="kpi-card">
      <div className="kpi-card__scope">
        <span className="kpi-card__dot" style={{ background: dotColor }} />
        {scope}
      </div>
      <div className="kpi-card__amount">
        {loading ? <span className="kpi-balance-skeleton" /> : amount}
      </div>
      <div className="kpi-card__sub">
        <span>{subText}</span>
        {delta && deltaDir && (
          <span className={`kpi-card__delta kpi-card__delta--${deltaDir}`}>
            {deltaDir === "up" ? "▲" : "▼"} {delta}
          </span>
        )}
      </div>
    </div>
  );
}

export default KpiCard;
